export const locales = ["en", "es"] as const
export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = "en"

export const timeZone = "America/Los_Angeles"

export const localeNames: Record<Locale, string> = {
    en: "English",
    es: "Español",
}

// Prepare for future expansion
// Uncomment and add as needed:
// export const futureLocales = ['fr', 'pt', 'de'] as const

export function isValidLocale(locale: string): locale is Locale {
    return locales.includes(locale as Locale)
}
